import React, { useContext } from 'react'
import { Context } from '../../contexts/Context'
import place from '../../assets/place.png'
import schedule from '../../assets/schedule.png'
import { Box, CircularProgress } from '@mui/material'

export default function Results ({ props }) {
  const { handleZoom, nearByCenters, originLocation } = props
  const { handleClinicClick, selectedClinic } = useContext(Context)
  if (!originLocation && !nearByCenters) {
    return (
      <div className='results-list allow-location'>
        <span style={{ marginTop: '30px', fontSize: '70px' }} className='material-symbols-outlined'> error </span>
        <h2> Please allow location access or Search your location!</h2>
      </div>
    )
  }
  if (nearByCenters && nearByCenters.length < 1) {
    return (
      <div className='results-list no-results'>
        <span style={{ marginTop: '30px', fontSize: '70px' }} className='material-symbols-outlined'> error </span>
        <h2>No Result found</h2>
      </div>
    )
  }
  const iPhoneCheck = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

  const mobileDirectionUrl = (destinationLat, destinationLng) => {
    window.open(iPhoneCheck ? `maps://?daddr=${destinationLat},${destinationLng}` : `google.navigation:q=${destinationLat},${destinationLng}`, '_blank')
  }
  return (
    <div className='results-list'>
      {/* {nearByCenters && <button data-toggle='tooltip' title={resultComponent ? 'Open' : 'Close'} onClick={() => handleResultComponent(!resultComponent)} className={resultComponent ? 'open-btn list-btn' : 'close-btn list-btn'} /> } */}

      {nearByCenters
        ? nearByCenters.map(({ centerName, centerId, address, workingHours, contact, distance, duration, location }) =>
          <div
            key={centerId}
            className={selectedClinic === +centerId ? 'active-result' : 'result-clinic'}
            onClick={(e) => {
              e.preventDefault()
              handleClinicClick(+centerId)
              handleZoom(17)
            }}
          >
            <div>
              <p id='title'>{centerName}</p>
              <span id='address'>
                <img width='19' src={place} alt='address' />
                <p>{(address?.address1 || '') + ' ' + (address?.address2 || '') + ' ' + (address?.city || '') + ', ' + (address?.state || '') + ' ' + (address?.pin || '')}</p>
              </span>

              <span>
                <span>
                  <span style={{ color: '#4285f4' }} className='material-symbols-outlined'>call</span>
                  <p>{contact || 'Not Available'}</p>
                </span>
                <span style={{ marginLeft: '10px' }}>
                  <img width='17' src={schedule} alt='working hours' />
                  <p> {(workingHours?.start && workingHours?.end) ? (workingHours?.start + ' to ' + workingHours?.end) : 'NA'}</p>
                </span>
              </span>

              {distance?.text && duration?.text &&
                <span>
                  <span style={{ color: '#4285f4' }} className='material-symbols-outlined'>directions_car</span>
                  <p style={{ marginLeft: '6px' }}>{duration?.text} ({distance?.text})</p>
                </span>}
            </div>
            <div>
              <button
                className='mobile-directions'
            //  style={{ position: 'absolute', }}
                data-toggle='tooltip' title='Direction' id='show-directions'
                onClick={() => {
                  mobileDirectionUrl(location.coordinates[1], location.coordinates[0])
                // event.stopPropagation()
                }}
                rel='noreferrer' target='_blank'
              >
                <span style={{ fontSize: '40px', color: '#178AD1' }} className='material-symbols-outlined'>assistant_direction</span>
              </button>

              <button
              // style={{ position: 'absolute'}}
                data-toggle='tooltip' title='Direction' id='show-directions'
                className='web-directions'
                onClick={() => (window.open(`https://www.google.com/maps/dir/?api=1&destination=${location.coordinates[1]},${location.coordinates[0]}&origin=${originLocation.lat},${originLocation.lng}&travelmode=driving`))}
                rel='noreferrer' target='_blank'
              >
                <span style={{ fontSize: '40px', color: '#178AD1' }} className='material-symbols-outlined'>assistant_direction</span>
              </button>
            </div>
          </div>
        )
        : <Box sx={{ marginTop: '10vh', display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
          </Box>}
    </div>
  )
}
